export const envConfig = {
  cmsCredentialsSecretName: `${process.env.STAGE}-Contentfulkeys`,
  STAGE: process.env.STAGE,
  cmsCreds: {
    CONTENTFUL_BEARER_TOKEN: process.env.CONTENTFUL_BEARER_TOKEN,
    CONTENTFUL_SPACE_ID: process.env.CONTENTFUL_SPACE_ID,
    CONTENTFUL_ENVIRONMENT: process.env.CONTENTFUL_ENVIRONMENT,
    CONTENTFUL_PREVIEW_ACCESS_TOKEN: process.env.CONTENTFUL_PREVIEW_ACCESS_TOKEN,
    CONTENTFUL_PREVIEW_SECRET: process.env.CONTENTFUL_PREVIEW_SECRET,
    CONTENTFUL_YOUTUBE_API_KEY: process.env.CONTENTFUL_YOUTUBE_API_KEY,
  },
  VALKEY_HOST: process.env.VALKEY_HOST,
  VALKEY_PORT: process.env.VALKEY_PORT,
  VALKEY_HREFLANG_DATABASE: process.env.VALKEY_HREFLANG_DATABASE,
};
